import { render } from "./TransportStatus.vue?vue&type=template&id=61e02194"
import script from "./TransportStatus.vue?vue&type=script&lang=js"
export * from "./TransportStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__